// src/redux/actions/siteActions.js
export const SET_TIME_RANGE = 'SET_TIME_RANGE';

export const setAlerttimerange = (timerange) => ({
  type: SET_TIME_RANGE,
  payload: timerange,
});
